<!-- Hero Section -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="healthcare-heading mb-3">
                        Insurtech Software Development Solutions for Modern Insurance Companies
                    </h1>
                    <!-- <p class="healthcare-subheading1 mb-4">
            Health Care Industries
          </p> -->
                    <p class="healthcare-subheading2 mb-4">
                        Elevate your insurance processes with secure, scalable, and AI-powered insurance software
                        development solutions. Deploy production-ready insurance software significantly faster with our
                        AI-accelerated development approach.
                    </p>
                    <!-- <p class="healthcare-subheading3 mb-4">
            We optimize your healthcare workflows through our custom-built software solutions.
          </p> -->
                    <div class="mb-5 contact-btn">
                        <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
                        <button class="btn hire-btn hire" (click)="freeConsultation()">
                            Book a Free Consultation
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/industries/insurtech/insurtech-herovideo.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Software Solutions in Healthcare Section -->
<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mx-auto">
            <h2>Why Insurtech Software Development Matters</h2>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="solutions-image-container">
                    <div class="solution-image-card image-one">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/insurtech/insurtech-img1.png" alt="Team collaborating on computer">
                    </div>
                    <div class="solution-image-card image-two">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/insurtech/insurtech-img2.png"
                            alt="Two colleagues looking at a laptop">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="solutions-content">
                    <p>
                        The insurance industry continues to face rising operational costs due to manual workflows,
                        legacy systems, and evolving customer expectations, which are hindering growth and
                        profitability. Traditional development cycles to deliver new capabilities are too slow for
                        today's competitive landscape.
                    </p>
                    <p>
                        These challenges slow down underwriting, delay claims processing, and limit business growth.
                        Insurtech software development empowers insurance companies to modernize their operations
                        through automation, AI-driven decision-making, and digital insurance platform development.
                    </p>
                    <p>As a trusted software development company for the insurance industry, Kalpita Technologies
                        delivers custom-built solutions that streamline policy management, enhance customer engagement,
                        ensure regulatory compliance (SOC2, GDPR, HIPAA), and accelerate the launch of innovative
                        insurance products. </p>
                    <div class="features-list">
                        <ul>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Faster
                                time-to-market through AI-accelerated development</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Faster, automated
                                claims processing reducing cycle time from weeks to hours</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Streamlined
                                end-to-end policy management with real-time data synchronization</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Better customer
                                experience with digital tools and intelligent self-service portals</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">AI-driven
                                underwriting improving accuracy and reducing risk exposure</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Higher efficiency
                                through workflow automation</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our Solutions & Impact Section -->
<section class="impact-section" #impactSection>
    <div class="container">

        <!-- Moved Heading inside the animation container or keep separate -->
        <div class="text-center">
            <h2 class="impact-heading">Kalpita Technologies’ Insurtech Solutions</h2>
        </div>

        <div class="row align-items-center impact-main-content">
            <!-- Left Column: Text Animation -->
            <div class="col-lg-6" [@fadeInUpStagger]="impactSectionVisible ? 'visible' : 'hidden'">

                <p class="impact-description animate-item">
                    Kalpita Technologies provides end-to-end <strong>insurance software development services,</strong>
                    helping insurers
                    digitize, automate, and scale their core operations. Whether you’re looking to integrate AI in
                    insurance, accelerate claims, optimize agent performance, or build a future-ready policy
                    administration system, Kalpita delivers secure, compliant, and scalable solutions tailored to your
                    business model with measurable ROI such as,
                </p>
                <ul class="simple-impact-list animate-item">
                    <li>
                        50% Faster Processing
                    </li>
                    <li>
                        70% Less Manual Work
                    </li>
                    <li>
                        30% Increase in Operational Efficiency
                    </li>
                </ul>
            </div>

            <!-- Right Column: 3D Tilt Image -->
            <div class="col-lg-6">
                <!-- Added 'tilt-card' class here -->
                <div class="impact-image-wrapper tilt-card">
                    <img src="../../../../assets/industries/insurtech/insurtech-solutions-img.png"
                        alt="Developer working on multiple screens">
                    <!-- Optional: Add a shine/glare element for 3D effect -->
                    <div class="shine"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Case Studies Section -->
<section class="case-studies-section">
    <div class="container">

        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Success Stories: How We Deliver Impactful Insurtech Results</h2>
                <!-- <p class="section-subheading">Real-world examples of our healthcare solutions in action.</p> -->
            </div>
        </div>

        <!-- Slider Wrapper -->
        <div class="case-study-slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

            <!-- The Sliding Track -->
            <div class="slider-viewport">
                <div class="slider-track" [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'">

                    <!-- Loop through Case Studies -->
                    <div class="case-study-slide" *ngFor="let study of caseStudies">
                        <div class="row align-items-center">

                            <!-- Image Column (Left) -->
                            <div class="col-lg-5 d-flex justify-content-center">
                                <div class="case-study-image-wrapper">
                                    <img [src]="study.image" [alt]="study.title" class="img-fluid">
                                </div>
                            </div>

                            <!-- Content Column (Right) -->
                            <div class="col-lg-7">
                                <div class="case-study-content">
                                    <h3 class="case-study-title">{{ study.title }}</h3>
                                    <p class="case-study-description">
                                        {{ study.description }}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- End Loop -->

                </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-dots">
                <span *ngFor="let study of caseStudies; let i = index" class="dot" [class.active]="i === currentSlide"
                    (click)="goToSlide(i)">
                </span>
            </div>

        </div>
    </div>
</section>
<!-- Testimonial Section -->
<!-- <section class="written-testimonial-section custom-testimonial written-testimonial-wrapper">
  <h2 class="written-heading">Testimonials</h2>

  <app-clients-testimonal [hideHeading]="true"></app-clients-testimonal>
</section> -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h2 class="healthcare-heading mb-3">
                        Testimonials
                    </h2>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="testimonials()">
                            See What Our Clients Say
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <img src="../../../../assets/clientscta/clientsctaimage.webp" alt="Clients CTA"
                        class="img-fluid testimonial-hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- FAQ -->
<app-faq [faqList]="InsuranceFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Build the Future of Insurance with Kalpita’s Insurtech Solutions</h2>
                <p style="color: #ffffff;">Discover how AI-accelerated development can help you launch innovative
                    insurance products 60% faster,
                    reduce operational costs, and deliver exceptional customer experiences.</p>
                <div class="mb-5 cta-btn-group">
                    <!-- <button class="btn btn-get-started me-3" (click)="getStarted()">
            Get Started
          </button> -->
                    <button class="btn btn-schedule-demo" (click)="freeConsultation()">
                        Schedule a Free Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Industries -->
<app-explore-more-industries></app-explore-more-industries>